export default "__VITE_ASSET__BD$23WJF__"